import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

function MarketInformationText(props) {
  return (
    <div className={styles.centeredGrayedText}>
      <Text centered>{props.text}</Text>
    </div>
  );
}

MarketInformationText.propTypes = {
  // eslint-disable-next-line react/require-default-props
  text: PropTypes.string
};

export default MarketInformationText;
